import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


// It is used to define our endpoints and allow to create the API slice
export const routeOneApi = createApi({
  // The unique key that defines where the Redux store will store our cache.
  reducerPath: 'routeOneApi',

  // The base query to request data.
  // RTK Query ships with fetchBaseQuery, which is a lightweight fetch wrapper that automatically handles request headers and response parsing in a manner similar to common libraries like axios.
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['RouteOne'],
  keepUnusedDataFor: 86400000,
  refetchOnMountOrArgChange: 1,
  // The set of operations that we want to perform against the server.
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: (data) => ({
        url: `route_one?page=${data.page}&size=${data.size}&searchid=${data.searchquery && data.searchquery}`,
        method: 'GET',
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['RouteOne'],
    }),

    deleteCountries: builder.mutation({
      query: (data) => {
        return {
          url: `route_one/${data.id}`,
          method: 'DELETE',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
    keepUnusedDataFor: 86400000,
    invalidatesTags: ['RouteOne'],
    }),

    createCountries: builder.mutation({
      query: (data) => ({
        url: `route_one`,
        method: 'POST',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['RouteOne'],
    }),

    updateCountries: builder.mutation({
      query: (data) => ({
        url: `route_one/${data.id}`,
        method: 'PUT',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['RouteOne'],
    }),

  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetAllCountriesQuery, useDeleteCountriesMutation, useCreateCountriesMutation, useUpdateCountriesMutation } = routeOneApi